import React from 'react';
import { supabase, authEnabled } from '../supabase';
import { setStoredTheme, applyTheme } from '../theme';
import pkg from '../../package.json';
import wordmark from '../assets/jvista-wordmark.png';
import brandIcon from '../assets/jvista-icon.png';

// Beta flag — appends " (beta)" to the version label. Flip to false at GA.
export const IS_BETA = true;

// "1.0.0" -> "V1.0 (beta)" while IS_BETA (single source of truth: package.json)
export const APP_VERSION_LABEL =
  `V${pkg.version.split('.').slice(0, 2).join('.')}${IS_BETA ? ' (beta)' : ''}`;

// Product tagline shown next to the version in the header and login card.
export const APP_TAGLINE = 'AI-powered solar cell simulator';

export default function Header({ session, theme = 'dark', onThemeChange }) {
  async function handleLogout() {
    if (!supabase) return;
    await supabase.auth.signOut();
  }
  function toggleTheme() {
    const next = theme === 'dark' ? 'light' : 'dark';
    if (onThemeChange) onThemeChange(next);
    setStoredTheme(next);
    applyTheme(next);
  }
  const email = session?.user?.email;
  const showAuthInfo = authEnabled && email;

  return (
    <header className="header">
      <div className="header-logo">
        <img src={brandIcon} alt="JVISTA" className="header-logo-icon" />
        <img src={wordmark} alt={`JVISTA — ${APP_TAGLINE}`}
             className="header-logo-wordmark" />
        <span className="header-logo-sub">{APP_VERSION_LABEL} · {APP_TAGLINE}</span>
      </div>
      <div className="header-divider" />
      <span className="header-tag">Photovoltaic Simulation Platform</span>
      <div className="header-status">
        <div className="status-dot" />
        <span>API CONNECTED</span>
      </div>
      <div style={{
        marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 12,
        paddingRight: 20, fontFamily: 'IBM Plex Mono, monospace', fontSize: 13,
      }}>
        <button
          onClick={toggleTheme}
          title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          aria-label="Toggle theme"
          style={{
            width: 32, height: 32, padding: 0,
            background: 'var(--bg-2)', border: '1px solid var(--border)',
            color: 'var(--text-1)', borderRadius: 4, cursor: 'pointer',
            fontSize: 16, lineHeight: 1,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {theme === 'dark' ? '☀' : '☾'}
        </button>
        {showAuthInfo && (
          <>
            <span style={{ color: 'var(--text-2)' }}>{email}</span>
            <button
              onClick={handleLogout}
              style={{
                padding: '4px 10px', fontSize: 13,
                fontFamily: 'IBM Plex Mono, monospace',
                background: 'var(--bg-2)', border: '1px solid var(--border)',
                color: 'var(--text-1)', borderRadius: 3, cursor: 'pointer',
              }}
            >
              Log out
            </button>
          </>
        )}
      </div>
    </header>
  );
}
